export const ArrowUpIcon = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.5119 8.93056C11.7928 8.68981 12.2072 8.68981 12.4881 8.93056L19.4881 14.9306C19.8026 15.2001 19.839 15.6736 19.5695 15.9881C19.2999 16.3026 18.8264 16.339 18.5119 16.0694L12 10.4878L5.48811 16.0694C5.17361 16.339 4.70014 16.3026 4.43057 15.9881C4.161 15.6736 4.19743 15.2001 4.51192 14.9306L11.5119 8.93056Z"
        fill="currentColor"
      />
    </svg>
  )
}
